import { ProductListFilterInput } from 'gql/types';
import { TFunction } from 'i18next';
import { FiltersConfig } from 'modules/common/components/FilterChips/types';
import { formatEnum } from 'modules/common/utils/formatEnum';

export const createProductsTableChipsConfig = (
  t: TFunction
): FiltersConfig<ProductListFilterInput> => ({
  statuses: {
    label: t('status'),
    renderValue: formatEnum,
  },
  bloodType: {
    label: t('bloodType'),
    renderValue: (val) => String(val).replace('_', ''),
  },
  regionName: {
    label: t('region'),
  },
});

export const excludedFilterFields: (keyof ProductListFilterInput)[] = [
  'searchQuery',
  'orderId',
  'woocommerceCategory',
];
